
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UserModule } from '../../../store/modules/user';

import DialogImgLarge from '@/components/ImgLarge/index.vue';
import { getParts, getPartsAttribute } from '@/api/device';
import { addPatrs } from '@/api/order';
import { getCompanySet } from '@/api/system';
import { checkPermissionCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';

@Component({
  name: 'department',
  components: {
    DialogImgLarge
  }
})
export default class extends Vue {
  // 接受父组件的值
  @Prop({
    type: String,
    default: ''
  })
  companyId!: string;
  @Prop({
    type: Boolean,
    default: false
  })
  partsVisible!: Boolean;

  @Prop({
    type: Object,
    default: () => ({})
  })
  orderDetail!: Object;
  // 1 报修 2 添加 3 订单处理 4 任务处理 7安装交付选择
  @Prop({
    type: Number,
    default: 0
  })
  enterType!: Number;

  private partsActiveName = 'first';
  // 公司是否开启新版备件（开启后选择备件名称后需选择下级备件名称）
  private isNewSpareParts = false;
  private childQuery = {
    name: ''
  };
  private childData = [];
  private childMore = false;
  private childPage = 1;
  // 当前下级列表的父级（查询下级时传 parts_pid）
  private childPid: any = '';
  private childPidName = '';
  // 当前下级列表的父级行数据（含下级/型号数量，进入下级时入栈）
  private childPidRow: any = null;
  // 上级层级链（返回上一级用）
  private childPidStack: any[] = [];
  // 当前已选备件的下级备件数量（大于0时必须选择下级备件）
  private selectedChildrenCount = 0;
  // 当前已选备件（最后一级）的型号数量（大于0时必须选择型号）
  private selectedModelCount = 0;
  private partsQuery = {
    name: ''
  };
  private modelQuery = {
    name: ''
  };
  private attrQuery = {
    name: ''
  };
  private partsData = [];
  private loading = false;
  private modelData = [];
  private attrData = [];
  private partsResultactiveName = 'right';
  private rightForm: any = {
    parts_id: '',
    stock_id:'0',
    parts_name: '',
    c_parts_id: '',
    c_parts_name: '',
    parts_model_id: '',
    stock_model_id:'0',
    parts_model_name: '',
    parts_serial_number: '',
    parts_specification: '',
    parts_remark: '',
    parts_amount: 1,
    parts_unit_price: '',
    parts_preset_unit_price: '',
    parts_price: '',
    parts_attribute_id: '',
    parts_attribute_name: '',
    image_short_path: '' // 东改 原 image_save_path
  };
  private isModifyPrice = false;
  private partsMore = false;
  private modelMore = false;
  private attributeMore = false;

  private partsPage = 1;
  private modelPage = 1;
  private attributePage = 1;

  created() {
    if (this.companyId) {
      if (UserModule.getCompany && UserModule.getCompanyId === this.companyId) {
        this.isModifyPrice = (UserModule.getCompany as any).is_modify_price === '1';
      } else {
        this.isModifyPrice = false;
      }
    } else {
      if (UserModule.getCompany) {
        this.isModifyPrice = (UserModule.getCompany as any).is_modify_price === '1';
      }
    }

    this.getCompanySetData();
    this.getParts(0, 1, '');
  }

  // 获取公司设置 判断是否开启新版备件
  private getCompanySetData() {
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      vip_level: (UserModule.company as any).vip_level
    };
    getCompanySet(params).then(res => {
      if (res.data && res.data.companySet) {
        this.isNewSpareParts = parseInt(res.data.companySet.is_new_spare_parts) === 1;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }

  private addPatrs() {
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      parts_name: this.rightForm.parts_name,
      parts_id: this.rightForm.parts_id,
      c_parts_id: this.rightForm.c_parts_id,
      c_parts_name: this.rightForm.c_parts_name,
      parts_model_id: this.rightForm.parts_model_id,
      parts_model_name: this.rightForm.parts_model_name,
      // 东改 原 unit_price
      parts_unit_price: this.rightForm.parts_unit_price,
      parts_preset_unit_price: this.rightForm.parts_preset_unit_price,
      parts_amount: this.rightForm.parts_amount,
      parts_price: this.rightForm.parts_price,
      image_save_path: this.rightForm.image_short_path,
      parts_attribute_id: this.rightForm.parts_attribute_id,
      parts_attribute_name: this.rightForm.parts_attribute_name,
      parts_serial_number: this.rightForm.parts_serial_number,
      parts_specification: this.rightForm.parts_specification,
      parts_remark: this.rightForm.parts_remark
    };
    if ((this.orderDetail as any).order) {
      params.order_id = (this.orderDetail as any).order.id;
    }
    if ((this.orderDetail as any).order_service) {
      params.order_service_id = (this.orderDetail as any).order_service.id;
    }
    if ((this.orderDetail as any).order_task) {
      params.order_task_id = (this.orderDetail as any).order_task.id;
    }
    addPatrs(params)
      .then((res) => {
        params.id = res.data.id;
        //增加备件路径字段
        this.showSecussMsg('添加成功');
        this.$emit('confirm', params);
      })
      .catch((error) => {
        this.showErrorMsg(error.msg);
      });
  }

  // 点击备件列表 跳转 型号
  private clickRadioParts(val: any) {
    if(checkPermissionCompany(UserModule.getCompanyId, Type.Stock)&&parseInt(UserModule.getCompany.is_sync_spare_parts)===1&&parseInt(val.stock_id)===0){
      this.showErrorMsg('此备件没有同步库存');
      return
    }
    if (this.isNewSpareParts && this.parseCount(val.children_count) > 0) {
      // 开启新备件且有下级备件：必须选择下级备件，进入下级备件名称
      this.partsActiveName = 'child';
    } else {
      this.partsActiveName = 'second';
    }
    if (this.rightForm.parts_id !== val.id) {
      this.rightForm.parts_id = val.id;
      this.rightForm.stock_id=val.stock_id;
      this.rightForm.parts_name = val.name;
      //重新选择型号，清空原有型号重新加载
      this.modelData = [];
      this.modelMore = true;
      this.getParts(val.id, 1, '');
      this.rightForm.parts_model_id = '';
      this.rightForm.stock_model_id='0';
      this.rightForm.parts_model_name = '';
      this.rightForm.parts_unit_price = '';
      this.rightForm.parts_preset_unit_price = '';
      this.rightForm.parts_price = ''
      this.rightForm.parts_serial_number = '';
      this.rightForm.parts_specification = '';
      this.rightForm.parts_remark = '';
      this.rightForm.parts_attribute_name = ''
      // 重新选择备件名称，清空下级备件名称重新加载
      this.rightForm.c_parts_id = '';
      this.rightForm.c_parts_name = '';
      this.childQuery.name = '';
      this.childPidStack = [];
      this.childData = [];
      this.childMore = false;
      this.childPid = val.id;
      this.childPidName = val.name;
      this.childPidRow = val;
      // 记录当前选中备件的下级/型号数量（用于必选校验）
      this.selectedChildrenCount = this.parseCount(val.children_count);
      this.selectedModelCount = this.parseCount(val.model_count);
      if (this.isNewSpareParts && this.partsActiveName === 'child') {
        this.getChildParts(1, true);
      }
      // 东改 增加图片
      this.rightForm.image_short_path = '';
    }
  }

  // 点击下级备件名称列表（children_count>0 继续查询下级，无下级进入型号）
  private clickRadioChild(val: any) {
    if (this.rightForm.c_parts_id !== val.id) {
      this.rightForm.c_parts_id = val.id;
      this.rightForm.c_parts_name = val.name;
      // 记录当前选中下级备件的下级/型号数量（用于必选校验）
      this.selectedChildrenCount = this.parseCount(val.children_count);
      this.selectedModelCount = this.parseCount(val.model_count);
      //重新选择下级备件名称，清空原有型号重新加载
      this.modelData = [];
      this.modelMore = true;
      this.getParts(val.id, 1, '');
      this.rightForm.parts_model_id = '';
      this.rightForm.stock_model_id='0';
      this.rightForm.parts_model_name = '';
      this.rightForm.parts_unit_price = '';
      this.rightForm.parts_preset_unit_price = '';
      this.rightForm.parts_price = ''
      this.rightForm.parts_serial_number = '';
      this.rightForm.parts_specification = '';
      this.rightForm.parts_remark = '';
      this.rightForm.parts_attribute_name = ''
      this.rightForm.parts_attribute_id = '';
      // 东改 增加图片
      this.rightForm.image_short_path = '';
      if (this.selectedChildrenCount > 0) {
        // 有下级：必须选择下级备件，根据上级pid继续查询下级
        this.childPidStack.push(this.childPidRow || { id: this.childPid, name: this.childPidName });
        this.childPid = val.id;
        this.childPidName = val.name;
        this.childPidRow = val;
        this.childQuery.name = '';
        this.getChildParts(1);
      } else {
        // 没有下级：进入备件型号
        this.partsActiveName = 'second';
      }
    }
  }

  // 下级备件名称 返回上一级
  private childBackClick() {
    if (this.childPidStack.length === 0) {
      return;
    }
    const node = this.childPidStack.pop();
    this.childPid = node.id;
    this.childPidName = node.name;
    this.childPidRow = node;
    this.childQuery.name = '';
    this.rightForm.c_parts_id = node.id;
    this.rightForm.c_parts_name = node.name;
    // 恢复该级备件的下级/型号数量（该级有下级时仍必须选择下级备件）
    this.selectedChildrenCount = this.parseCount(node.children_count);
    this.selectedModelCount = this.parseCount(node.model_count);
    this.modelData = [];
    this.modelMore = true;
    this.getParts(node.id, 1, '');
    this.rightForm.parts_model_id = '';
    this.rightForm.stock_model_id='0';
    this.rightForm.parts_model_name = '';
    this.rightForm.parts_unit_price = '';
    this.rightForm.parts_preset_unit_price = '';
    this.rightForm.parts_price = ''
    this.rightForm.parts_serial_number = '';
    this.rightForm.parts_specification = '';
    this.rightForm.parts_remark = '';
    this.rightForm.parts_attribute_name = ''
    this.rightForm.parts_attribute_id = '';
    this.rightForm.image_short_path = '';
    this.getChildParts(1);
  }

  // 点击型号列表 跳转 属性
  private clickRadioModel(val: any) {
    if(checkPermissionCompany(UserModule.getCompanyId, Type.Stock)&&parseInt(UserModule.getCompany.is_sync_spare_parts)===1&&parseInt(val.stock_model_id)===0){
      this.showErrorMsg('此备件型号没有同步库存');
      return
    }
    this.partsActiveName = 'third';
    if (this.rightForm.parts_model_id !== val.id) {
      this.rightForm.parts_model_id = val.id;
      this.rightForm.stock_model_id=val.stock_model_id;
      this.rightForm.parts_model_name = val.name;
      this.rightForm.parts_unit_price = val.unit_price;
      this.rightForm.parts_preset_unit_price =  val.unit_price;
      this.rightForm.parts_serial_number = val.serial_number;
      this.rightForm.parts_specification = val.specification;
      this.rightForm.parts_remark = val.remark;
      // 东改 增加图片
      this.rightForm.image_short_path = val.image_short_path;
      this.inputChange();
      this.getPartsAttribute(1);
      this.rightForm.parts_attribute_name = ''
      this.rightForm.parts_attribute_name = '';
      this.rightForm.parts_attribute_id = '';
    }
  }

  // 点击 属性列表
  private clickRadioAttr(val: any) {
    this.rightForm.parts_attribute_name = val.name;
    this.rightForm.parts_attribute_id = val.id;
  }

  // 单价 数量变化后 计算金额
  private inputChange() {
    this.rightForm.parts_price =
      this.rightForm.parts_unit_price * this.rightForm.parts_amount;
  }

  // 解析接口返回的数量字段（容错：空值/非数字返回0）
  private parseCount(val: any) {
    const num = parseInt(val);
    return isNaN(num) ? 0 : num;
  }

  // 备件列表 loadMore
  private partsMoreClick() {
    this.getParts(0, this.partsPage + 1, this.partsQuery.name);
  }

  // 型号列表查询使用的备件id（新备件模式下为已选下级备件id）
  private get modelQueryPartsId(): any {
    return this.rightForm.c_parts_id || this.rightForm.parts_id;
  }

  // 型号列表 loadMore
  private modelMoreClick() {
    this.getParts(
      this.modelQueryPartsId,
      this.modelPage + 1,
      this.modelQuery.name
    );
  }

  // 下级备件名称列表 loadMore
  private childMoreClick() {
    this.getChildParts(this.childPage + 1);
  }

  // 下级备件名称列表 搜索
  private searchChild() {
    this.childPage = 1;
    this.getChildParts(this.childPage);
  }
  // 下级备件名称列表 清空
  private searchChildClean() {
    this.childQuery.name = '';
    this.childPage = 1;
    this.getChildParts(this.childPage);
  }

  // 下级备件名称列表 接口（与备件名称同一接口，多传上级备件名称id到parts_pid）
  private getChildParts(page: any, autoSkip: boolean = false) {
    this.childPage = page;
    let isApply = 0;
    switch (this.enterType) {
      case 7:
          isApply = 1;
        break;
      default:
          isApply = 0;
        break;
    }
    const params = {
      company_id: this.companyId ? this.companyId : UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      parts_name: this.childQuery.name,
      parts_pid: this.childPid,
      page: page,
      is_apply: isApply,
      is_need_child_count: 1
    };
    this.loading = true;
    getParts(params)
      .then((res: any) => {
        this.loading = false;
        if (res.data) {
          if (parseInt(page) === 1) {
            this.childData = res.data.list;
          } else {
            this.childData = this.childData.concat(res.data.list);
          }
          if (parseInt(page) < parseInt(res.data.page_count)) {
            this.childMore = true;
          } else {
            this.childMore = false;
          }
          // 选择备件名称后自动进入下级：无下级时直接跳转备件型号
          if (autoSkip && parseInt(page) === 1 && (!res.data.list || res.data.list.length === 0)) {
            this.selectedChildrenCount = 0;
            this.partsActiveName = 'second';
          }
        } else {
          this.childData = [];
          this.childMore = false;
          if (autoSkip) {
            this.selectedChildrenCount = 0;
            this.partsActiveName = 'second';
          }
        }
      })
      .catch((error) => {
        this.loading = false;
        let msg = error.msg;
      });
  }

  // 备件列表 搜索
  private searchParts() {
    this.partsPage = 1;
    this.getParts(0, this.partsPage, this.partsQuery.name);
  }
  // 备件列表 清空
  private searchPartsClean() {
    this.partsPage = 1;
    this.partsQuery.name = '';
    this.getParts(0, this.partsPage, '');
  }
  // 型号列表 搜索
  private searchModel() {
    this.modelPage = 1;
    this.getParts(
      this.modelQueryPartsId,
      this.modelPage,
      this.modelQuery.name
    );
  }
  // 型号列表 清空
  private searchModelClean() {
    this.modelQuery.name = '';
    this.modelPage = 1;
    this.getParts(this.modelQueryPartsId, this.modelPage, '');
  }

  // 备件列表 接口
  private getParts(val: any, page: any, name: any) {
    if (parseInt(val) === 0) {
      this.partsPage = page;
    } else {
      this.modelPage = page;
    }
    let isApply = 0;
    switch (this.enterType) {
      case 7:
          isApply = 1;
        break;
      default:
          isApply = 0;
        break;
    }
    const params = {
      company_id: this.companyId ? this.companyId : UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      parts_name: name,
      parts_id: val,
      page: page,
      is_apply:isApply,
      is_need_child_count: 1
    };
    getParts(params)
      .then((res) => {
        if (res.data) {
          if (parseInt(val) === 0) {
            if (page === 1) {
              this.partsData = res.data.list;
            } else {
              this.partsData = this.partsData.concat(res.data.list);
            }
            if (parseInt(page) < parseInt(res.data.page_count)) {
              this.partsMore = true;
            } else {
              this.partsMore = false;
            }
          } else {
            if (page === 1) {
              this.modelData = res.data.list;
            } else {
              this.modelData = this.modelData.concat(res.data.list);
            }
            if (parseInt(page) < parseInt(res.data.page_count)) {
              this.modelMore = true;
            } else {
              this.modelMore = false;
            }
          }
        } else {
          this.partsData = [];
        }
      })
      .catch((error) => {
        let msg = error.msg;
      });
  }

  // 属性列表 搜索
  private attrSearch() {
    this.attributePage = 1;
    this.getPartsAttribute(this.attributePage);
  }
  // 属性列表 清空
  private attrSearchClean() {
    this.attrQuery.name = '';
    this.attributePage = 1;
    this.getPartsAttribute(this.attributePage);
  }
  // 备件列表 接口
  private getPartsAttribute(page: any) {
    const params = {
      company_id: UserModule.getCompanyId,
      name: this.attrQuery.name,
      page: page
    };
    getPartsAttribute(params)
      .then((res) => {
        if (res.data) {
          if (page === 1) {
            this.attrData = res.data.list;
          } else {
            this.attrData = this.attrData.concat(res.data.list);
          }
          if (parseInt(page) < parseInt(res.data.page_count)) {
            this.attributeMore = true;
          } else {
            this.attributeMore = false;
          }
        } else {
          this.attrData = [];
        }
      })
      .catch((error) => {
        let msg = error.msg;
      });
  }
  // tab 列表切换验证
  private handlePartsClick(activeName: any, oldActiveName: any) {
    if (activeName === 'second' && !this.rightForm.parts_id) {
      this.$notify({
        title: '提示',
        message: '请选择备件',
        duration: 3000,
        offset: 100,
        type: 'error'
      });
      return false;
    }
    // 有下级备件时必须先选择下级备件，才能进入备件型号
    if (this.isNewSpareParts && activeName === 'second' && this.selectedChildrenCount > 0) {
      this.$notify({
        title: '提示',
        message: '该备件有下级备件，请先选择下级备件',
        duration: 3000,
        offset: 100,
        type: 'error'
      });
      return false;
    }
    if (this.isNewSpareParts && activeName === 'child' && !this.rightForm.parts_id) {
      this.$notify({
        title: '提示',
        message: '请选择备件',
        duration: 3000,
        offset: 100,
        type: 'error'
      });
      return false;
    }
    if (activeName === 'third' && !this.rightForm.parts_model_id) {
      this.$notify({
        title: '提示',
        message: '请选择备件型号',
        duration: 3000,
        offset: 100,
        type: 'error'
      });
      return false;
    }
  }
  // 图片放大
  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private confirm() {
    console.log(this.rightForm);
    // 有下级备件时必须选择下级备件
    if (this.isNewSpareParts && this.selectedChildrenCount > 0) {
      this.showErrorMsg('请选择下级备件');
      return;
    }
    // 最后一级备件有型号时必须选择备件型号
    if (this.selectedModelCount > 0 && !this.rightForm.parts_model_id) {
      this.showErrorMsg('请选择备件型号');
      return;
    }
    if (checkPermissionCompany(UserModule.getCompanyId, Type.PersonStock)) {
      if (!this.rightForm.parts_model_id) {
        this.showErrorMsg('请选择备件型号');
        return;
      }
    }
    // 公司库存判断
    if(checkPermissionCompany(UserModule.getCompanyId, Type.Stock)&&parseInt(UserModule.getCompany.is_sync_spare_parts)===1){
      if (parseInt(this.rightForm.stock_id)===0) {
        this.showErrorMsg('此备件没有同步库存');
        return;
      }
      if (!this.rightForm.parts_model_id) {
        this.showErrorMsg('请选择备件型号');
        return;
      }
      if (parseInt(this.rightForm.stock_model_id)===0) {
        this.showErrorMsg('此备件型号没有同步库存');
        return;
      }
    }
    switch (this.enterType) {
      case 1:
      case 2:   
      case 7:
        this.rightForm.image_save_path = this.rightForm.image_short_path;
        this.$emit('confirm', this.rightForm);
        this.$emit('close', false);
        break;
      case 3:
        this.addPatrs();
        break;
      case 4:
        this.addPatrs();
        break;
    }
  }
  private close() {
    this.$emit('close', false);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
